module.exports = __webpack_public_path__ + "static/media/naztec.a06e3464.svg";